import { Injectable } from '@angular/core';
import { SingletonServiceGuard } from '@lsq-frontend/angular-shared/features/generic-get-services';
import { Subject } from 'rxjs';
import { ActionSheet } from '../../models/common';

/**
 * Service for showing the action sheet.
 */
@Injectable({ providedIn: 'root' })
export class ActionSheetService {
    private _actionSheetSubject = new Subject<ActionSheet>();
    private _actionSheetLoadingSubject = new Subject<boolean>();
    public actionSheetStream = this._actionSheetSubject.asObservable();
    public actionSheetLoadingStream = this._actionSheetLoadingSubject.asObservable();

    constructor() {
        SingletonServiceGuard.register('ActionSheetService');
    }

    public showActionSheet(actionSheet: ActionSheet): void {
        this._actionSheetSubject.next(actionSheet);
        this._actionSheetLoadingSubject.next(false);
    }

    public closeActionSheet(): void {
        this._actionSheetSubject.next(null);
    }

    public showLoading(): void {
        this._actionSheetLoadingSubject.next(true);
    }
}
